<ng-container *transloco="let t; read: 'ime.system.role'">
  <ng-select #select class="select-sm form-control"
             [items]="allItems$ | async"
             [name]="name"
             [multiple]="true"
             [searchFn]="searchFn"
             [(ngModel)]="entityIds"
             (change)="onSelectionChanged($event)"
             bindLabel="Name"
             bindValue="Id"
             appendTo="body">
    <ng-template ng-label-tmp let-item="item" let-clear="clear">
      <span class="ng-value-icon left" (click)="clear(item); select.close()" aria-hidden="true">×</span>
      <span class="ng-value-icon left" (click)="edit(item); select.close()"><svg viewBox="0 0 6 8" class="icon small" inlineSVG="#pencil"></svg></span>
      <span class="ng-value-label">{{item.Name}}</span>
    </ng-template>
    <ng-template ng-footer-tmp>
      <ng-container [ngTemplateOutlet]="footer" [ngTemplateOutletContext]="{select: select}"></ng-container>
    </ng-template>
    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
      <ng-container [ngTemplateOutlet]="notfound" [ngTemplateOutletContext]="{select: select, searchTerm: searchTerm}">
      </ng-container>
    </ng-template>
  </ng-select>
  <ng-template #notfound let-searchTerm="searchTerm" let-select="select">
    <div class="ng-option disabled">
      <button type="button" class="btn btn-sm btn-outline-primary me-1" (click)="select.close(); addNew(searchTerm)">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
        {{t('Add')}} "{{searchTerm}}"
      </button>
    </div>
  </ng-template>
  <ng-template #footer let-select="select">
    <button type="button" *ngIf="entityId || entityIds?.length" class="btn btn-sm btn-outline-primary me-1"
      (click)="select.close(); edit()">
      <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
    </button>
    <button type="button" class="btn btn-sm btn-outline-primary me-1" (click)="select.close(); addNew()">
      <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
    </button>
  </ng-template>
  </ng-container>
